/* eslint-disable react/react-in-jsx-scope */
import { Overrides } from 'baseui/overrides';
import { dropdownStyle, pointerCursor, popoverStyle } from './styles';
import { MIcon } from '../Icon';
import React from 'react';
import { borderRadius } from '../../Utilities/utils/Theming';

export const overrides = (props: any, isExpanded: boolean, css: any) => {
	return {
		Dropdown: {
			style: {
				...dropdownStyle(),
				...borderRadius('var(--epods--border-radius)'),
			},
			props: {
				'data-epo': 'epo-dossier-input',
			},
		},
		OptionContent: {
			props: {
				'data-epo': 'epo-dossier-input',
			},
		},
		IconsContainer: {
			style: {
				...pointerCursor(props),
			},
		},
		SelectArrow: {
			component: () => (
				<span
					className={css({
						pointerEvents: 'none',
						display: 'flex',
					})}
				>
					<MIcon
						icon={isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
						color={
							props.disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--color-text-primary)'
						}
						aria-hidden="true"
						aria-label="Open modal"
						size="18px"
					/>{' '}
				</span>
			),
		},
		DropdownContainer: {
			style: {
				borderRadius: 'var(--epods--border-radius)',
			},
		},
		Popover: {
			props: {
				overrides: {
					Body: {
						style: () => ({
							...popoverStyle(),
						}),
						props: {
							'data-epo': 'epo-dossier-input',
						},
					},
					Inner: {
						style: {
							...borderRadius('var(--epods--border-radius)'),
						},
					},
				},
			},
		},
	} as Overrides<any>;
};
